// Device detection
export const isAndroid = () => window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
export const isIphone = () => /iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
export const isIpad = () => /iPad/.test(window.navigator.userAgent) && !window.MSStream;

// Platform detection
export const isTablet = () => isIpad();
export const isPhone = () => isIphone() || isAndroid();
export const isMobile = () => isPhone() || isIpad();
export const isPortrait = () => (window.innerWidth < window.innerHeight);
export const isTouch = () =>  ("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
export const isWindows = () => navigator.platform.indexOf("Win") > -1;

function agentMatching(agent, includes, excludes) {
  if (includes.every(browser => agent.indexOf(browser) > -1)) {
    if (excludes.every(browser => agent.indexOf(browser) === -1)) {
      return true;
    }
  }
  return false;
}

// Logic from https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#browser_name
export function browserClasses() {
  const agent = navigator.userAgent.toLowerCase();
  const classes = [];

  if (agentMatching(agent, ["safari"], ["chrome", "android"]))
    classes.push("safari");

  if (agentMatching(agent, ["chrome"], []))
    classes.push("chrome");

  if (agentMatching(agent, ["firefox"], []))
    classes.push("firefox");

  if (agentMatching(agent, ["opera"], []))
    classes.push("opera");

  if (agentMatching(agent, ["msie"], []))
    classes.push("msie");

  if (agentMatching(agent, ["edge"], []))
    classes.push("edge");

  if (isMobile()) classes.push("mobile")
  if (isTouch()) classes.push("touchevents")

  return classes;
}
